import React from "react"
import Base from "./Base"
import { Card, Row, Col, Table, Typography, Form, message, Spin, Button, Input} from "antd"
import { Auth, API } from "aws-amplify"
import { connect } from "react-redux"
import pagoMisCuentas from "../../Images/pagoMisCuentas.png"
import pagar from "../../Images/pagar.png"
import {withRouter } from 'react-router-dom';
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"


const { Text } = Typography;


class PagoServicios extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            loadingPlans: true,
            loadingCard:false,
            changePayment: false,
            cbu: null,
            newCbu : null,
            user:{
                vep: 'Pago Mis Cuentas',
                cat_monotributo:'A'
            },
            plan:{

            },
            medioPago:{
            }

        };
        }

        componentDidMount() {
            if (this.props.login.user_data.estado_usuario ==='INACTIVO'|| this.props.login.user_data.estado_usuario === 'INCOMPLETO'){
                this.props.history.push('/')
            }else{

            this.setState({user:this.props.login.user_data})
            Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/planes/' + this.state.user.plan_id,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.setState({ loadingPlans: false, plan: response })
                    })
                    .catch(err => {
                        message.error('Error obteniendo datos de plan')
                        console.log(err)})
            })

            if (this.props.login.user_data.mp_customer_card_id !== null || this.props.login.user_data.mp_customer_card_id === undefined){
                this.setState({loadingCard:true})
                Auth.currentSession()
                    .then(response => {
                        API.get(
                            'test',
                            '/payment/card',
                            {
                                headers: {
                                    Authorization: response.getIdToken().getJwtToken()
                                },
                                queryStringParameters:{
                                    mp_customer_id:this.state.user.mp_customer_id,
                                    mp_customer_card_id:this.state.user.mp_customer_card_id
                                }
                            }
                        )
                            .then(response => {
                                this.setState({ loadingCard: false, medioPago: response })
                            })
                            .catch(err => {
                                message.error('Error obteniendo medios de pago')
                                this.setState({loadingCard:false})
                                })
                        })
            }

            if (this.props.login.user_data.cbu){
                Auth.currentSession()
                    .then(response => {
                        API.get(
                            'test',
                            '/root/users/me',
                            {
                                headers: {
                                    Authorization: response.getIdToken().getJwtToken()
                                }
                            }
                        )
                        .then(response => {
                            this.setState({newCbu : response.cbu})
                        })
                        .catch(err =>{
                            message.error('Error cargando datos de usuario')
                            this.props.history.push('/')
                        })
                    })
            }
        }
    }

        call_api(medioPagoMonotributo){
            let queryStringParameters=null
            if(medioPagoMonotributo==='pagar'){
                queryStringParameters={
                    vep:'pagar'
                }}
            else if(medioPagoMonotributo==='cbu'){
                queryStringParameters={
                    cbu:this.state.cbu
                }
            }
            else if (medioPagoMonotributo ==='pagoMisCuentas'){
                queryStringParameters={
                    vep:'pagoMisCuentas'
                }
            }
            this.setState({loadingCard:true})
            Auth.currentSession()
              .then(session => {
                  API.put(
                      'test',
                      '/root/users/me/vep',
                      {
                          headers: {
                              Authorization: session.getIdToken().getJwtToken()
                          },
                          queryStringParameters: queryStringParameters
                      }
                  )
                  .then(response => {
                      message.success("Medio de Pago actualizado")
                     this.setState({loadingCard:false, changePayment:false})
                     this.props.UserDataLoad(this.state.user)
                     this.props.history.push('/')
                  })
                  .catch(err => {
                      message.error("Error actualizando medio de pago")
                      this.setState({ loadingCard: false, changePayment:false })
                    })
              })
        }

    setCbu(e){
        this.props.form.validateFieldsAndScroll('cbu', { first: true }, (err, values) => {
            if (!err) {
                this.call_api('cbu')
             }
        })
    }

updateState(field, value){
    this.setState({field:value})
}


        paymentMethod(method){
            const new_data = {...this.state.user}
            new_data["vep"] = method
            this.setState({user:new_data, changePayment:!this.state.changePayment})
            this.call_api(method)
        }

        handleChange(field, value){
            const new_user={...this.state.user}
            new_user[field]=value
            this.setState({user:new_user})
        }


        callCambiarPlan(){
            this.props.history.push('/mejorar-plan')
        }
        callCambiarTarjeta(){
            this.props.history.push('/medio-pago/'+this.state.user.plan_id)
        }


        render() {
            let medioPagoMono=''
        if(this.state.loadingCard === true || this.state.loadingPlans === true){
            return (
                <Base
                selected="pago-servicios"
            >
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                <Col style={{minHeight:'360px'}}>
                    <Spin indicator={CustomSpinner}/>
                </Col>
            </Row>
            <Row></Row>
                </Base>)}

        else {
            if (this.state.user.vep){
                medioPagoMono = 'VEP: ' + this.state.user.vep
            } else if (this.state.user.cbu){
                medioPagoMono = 'CBU: ' + this.state.newCbu
            } else( medioPagoMono='No informado')

        let columns = [
            {
                title: 'Descripcion',
                dataIndex: 'descripcion',
                key: 'descripcion',
            },
            {
                title: 'Valor',
                dataIndex: 'valor',
                key: 'valor',
            }
        ];

        let dataLiquidando =[
            {
                key:'1',
                descripcion:'Plan Actual',
                valor:this.state.user.plan

            },
            {
                key:'2',
                descripcion:'Medio de pago',
                valor: this.state.plan.medio ==='Tarjeta'?'XXXX-XXXX-XXXX-'+this.state.medioPago.last_four_digits:'Ticket de pago'

            },
            {
                key:'3',
                descripcion:'Actualmente pagas',
                valor:parseInt(this.state.plan.costo/this.state.plan.plazo)

            },
            {
                key:'4',
                descripcion:'Vencimiento de plan',
                valor: this.state.plan.medio ==='Tarjeta'?'Suscripto mensualmente':this.state.user.fecha_fin
            }
        ];

        let dataMonotributo =[
            {
                key:'1',
                descripcion:'Categoria',
                valor:this.state.user.cat_monotributo
            },
            {
                key: '2',
                descripcion: 'Medio de Pago',
                valor: medioPagoMono
            },
            {
                key:'3',
                descripcion: 'Deuda c/ AFIP',
                valor:'$ '+(this.state.user.deuda_afip === null? '0':this.state.user.deuda_afip)

            }

        ];

    if (this.state.changePayment){

        const cbuValidator =(rule, value, callback)=>{
            if ((value.toString().length !== 22) || (isNaN(value))){
                callback('El CBU debe contener 22 numeros')
            }else {
                callback()
            }
        }

        const { getFieldDecorator } = this.props.form;



                return (
            <Base
                selected="pago-servicios">

                <div>
                <Text style={{fontSize:14}}>El pago de tus impuestos lo puedes hacer generando un Volante Electronico de Pago (VEP) y pagarlo cuando quieras desde tu homebanking, o bien ingresar el CBU de tu cuenta bancaria para que se debite automáticamente todos los meses. </Text>
                </div>
                <br></br>
                <Card
                    title={'Pagar mediante VEP'}
                    bodyStyle={{
                        borderRadius: "5px", height: "auto", textAlign: "center", marginTop: "5px", paddingTop: "40px",
                        paddingBottom: "20px", marginBottom:'10px'}}>

                            <Col lg={12}>
                                <Card style={{
                                    borderRadius: "5px", borderTop:'1px solid #e8e8e8', height: "auto", textAlign: "left", marginTop: "5px", paddingTop: "40px",
                                    paddingBottom: "20px", marginLeft:'10px', marginRight:'10px'
                                }} >
                                    <center><img alt="pagar" src={pagar} className="pagar" style={{ height: "80px", marginTop: "15px", marginBottom: "15px" }} /></center>
                                    <br></br>
                                    <center><Button onClick={()=>this.paymentMethod('pagar')}>Pagar (Link)</Button></center>
                                </Card>
                            </Col>

                            <Col lg={12}>
                                <Card style={{
                                    borderRadius: "5px", borderTop:'1px solid #e8e8e8' , height: "auto", textAlign: "left", marginTop: "5px", paddingTop: "40px",
                                    paddingBottom: "20px", marginLeft:'10px', marginRight:'10px'
                                }}>
                                    <center><img alt="pagoMisCuentas" src={pagoMisCuentas} className="pagoMisCuentas" style={{ height: "80px", marginTop: "15px", marginBottom: "15px" }} /></center>
                                    <br></br>
                                    <center><Button onClick={()=>this.paymentMethod("pagoMisCuentas")}>Pago Mis Cuentas</Button></center>
                                </Card>
                            </Col>
                </Card>
                <br></br>

                <Card
                    title={'Adherir débito automático'}
                    bodyStyle={{
                        borderRadius: "5px", height: "auto", textAlign: "center", marginTop: "5px", paddingTop: "40px",
                        paddingBottom: "20px", marginBottom:'10px'}}>
                    <Row gutter={[8,8]} type='flex' justify='center' align='top' style ={{marginBottom:'10px' ,marginTop:'10px'}}>
                        <Col >
                        <Form.Item>
                                    {
                                        getFieldDecorator('cbu', {
                                            rules: [
                                                {
                                                    required: false,
                                                    validator: cbuValidator
                                                },
                                            ]
                                        })(<Input
                                            placeholder="22 numeros sin espacios ni guiones"
                                            onChange={(e) => this.setState({cbu: e.target.value})}
                                        />)
                                    }
                        </Form.Item>
                        <Form.Item>
                            <Button
                                onClick={(e)=>this.setCbu(e)}
                            >
                                Suscribir Débito Automático
                            </Button>
                        </Form.Item>
                        </Col>
                    </Row>
                </Card>
            </Base>
            )}

    else{

        return (

            <Base
                title='Tus formas de pago'
                selected="pago-servicios"
            >
                <Row gutter={[8, 8]}>
                    <Col lg={12}>
                        <Card
                            title={'Liqui'}
                            style={{ marginBottom: 10}}
                        >
                            <Table dataSource={dataLiquidando} columns={columns} pagination={false} showHeader={false}/>
                            <Button style={{ marginBottom: 10, marginLeft:10, marginRight:10, marginTop:10}} placement='bottomRight' onClick={()=>this.callCambiarPlan()}>Cambiar de Plan</Button>
                            <Button style={{ marginBottom: 10, marginLeft:10, marginRight:10, marginTop:10}} placement='bottomLeft' onClick={()=>this.callCambiarTarjeta()}>Cambiar Medio de pago</Button>
                        </Card>
                    </Col>
                    <Col lg={12}>
                        <Card
                            title={'Monotributo'}
                            style={{ marginBottom: 10}}

                        >
                            {(this.state.user.vep === null || this.state.user.vep === undefined )&& (this.state.user.cbu === null || this.state.user.cbu === undefined)?
                            <Text>No contamos con informacion sobre cómo pagas tu Monotributo. Haz click<Button type='link' onClick={()=>this.setState({changePayment:!this.state.changePayment})}><b>aqui</b></Button> para seleccionar un medio de pago.</Text>
                            :<>
                           <Table dataSource={dataMonotributo} columns={columns} pagination={false} showHeader={false}/>
                           <Button style={{ marginBottom: 10, marginLeft:10, marginRight:10, marginTop:10}} placement='bottomLeft' onClick={()=>this.setState({changePayment:!this.state.changePayment})}>Cambiar Medio de pago</Button></>                            }
                        </Card>
                    </Col>

                </Row>
            </Base>

        );
    }}
}}

const PagoServ = Form.create({nombre:'pagoServicios'})(PagoServicios)
export default connect (mapStateToProps, mapDispatchToProps)(withRouter(PagoServ));